import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';

import styles from './plan-comparison-header.module.less';

/**
 * Header for the plans comparison page.
 */
export const PlanComparisonHeader = () => {
    const {gettext} = useI18n();
    const subtitle = gettext(
        "Don't want to buy courses one by one? Pick a plan to help you, your team, or your organization achieve outcomes faster.",
    );

    return (
        <div>
            <h1
                className={classNames(
                    'ud-heading-serif-xxxl',
                    'ud-text-responsive',
                    styles['main-title'],
                )}
            >
                {gettext('Choose a plan for success')}
            </h1>
            <div className={classNames('ud-text-lg', 'ud-text-responsive', styles.subtitle)}>
                {subtitle}
            </div>
        </div>
    );
};
